// Bounded metadata refresh for visible completed calls. Audio is never fetched.
export function createAutoCDR({api,scope,active,reload,notify=()=>{},delay=ms=>new Promise(r=>setTimeout(r,ms))}){
 let current='',generation=0;const attempts=new Map();
 return {async ensure(rows,filters){
  const pending=rows.filter(c=>c.ended&&(c.cdr_verified===false||c.cdr_needs_repair));if(!pending.length){current='';generation++;return;}
  const workspace=scope(),key=workspace+'|'+JSON.stringify(filters)+'|'+pending.map(c=>c.id).sort().join(',');
  if(current===key||attempts.get(key)>=3)return;current=key;const own=++generation;
  if(attempts.size>100)attempts.clear();
  const valid=()=>own===generation&&active()&&scope()===workspace;
  const day=t=>{const parts=Object.fromEntries(new Intl.DateTimeFormat('en-CA',{timeZone:filters.timezone,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date(t*1000)).map(p=>[p.type,p.value]));return `${parts.year}-${parts.month}-${parts.day}`;};
  // One day per request avoids scanning large gaps between visible calls.
  const days=[...new Set(pending.map(c=>day(c.started)))].slice(0,5);
  const limit=pending.some(c=>Date.now()/1000-c.ended<120)?3:1;
  notify('Synchronizing completed call results and agent associations…');
  try{for(let n=attempts.get(key)||0;n<limit&&valid();n++){
   if(n)await delay(n===1?5000:15000);if(!valid())return;attempts.set(key,n+1);
   let budget=4;for(const date of days){let cursor;for(let page=0;page<4&&budget>0&&valid();page++){
    budget--;const result=await api('/history/sync',{...filters,outcome:'',q:'',destination:'',queue:'',timezone:undefined,start:date,end:date,...(cursor?{cursor}:{})});if(!valid())return;cursor=result.cursor;if(!cursor)break;
   }}
   if(valid())await reload();
  }}catch(error){if(valid()){generation++;current='';notify('Automatic CDR refresh: '+error.message+'. Use Search FreePBX to retry.');}return;}
  finally{if(own===generation){current='';notify('Automatic refresh finished. Results not yet available from the PBX remain pending.');}}
 }};
}
